import React, { Component, Fragment } from "react";
import Functions from "../../../src/functions";
import { Link } from "react-router-dom";
import CustomFunctions from "../../../modules/functions";
import Manager from "../../../src/manager";

class InfoDataPanel extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
		hybridDetailOpen: false,
	};

	constructor(props) {
		super(props);
		this.createData2 = this.createData2.bind(this);
		this.createDataList = this.createData.bind(this);
		this.openHybridDetail = this.openHybridDetail.bind(this);
		this.closeHybridDetail = this.closeHybridDetail.bind(this);
		this.clickHandler = this.clickHandler.bind(this);
	}

	componentDidMount() {
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
		});
	}
	componentWillUnmount() {
		Functions.removeHybridWalletCSS();
	}
	openHybridDetail() {
		Functions.removeHybridWalletCSS();
		document.body.classList.add("hybrid-detail-open");
		this.setState({ hybridDetailOpen: true });
	}
	closeHybridDetail() {
		Functions.removeHybridWalletCSS();
		this.setState({ hybridDetailOpen: false });
	}
	getHybridWalletData() {
		let categoryList = [];
		let bundleList = [];
		try {
			const customerData = JSON.parse(sessionStorage.getCustomerData || "{}");
			categoryList = customerData.categoriesInfoList || [];
			bundleList = customerData.bundlesInfoList || [];
		} catch (e) {
			categoryList = [];
			bundleList = [];
		}
		if (categoryList.length === 0) {
			const fromAllData =
				this.state.data[0]?.allData?.value ||
				this.state.data[0]?.allData?.data?.allData;
			if (fromAllData) {
				categoryList = fromAllData.categoriesInfoList || [];
				bundleList = fromAllData.bundlesInfoList || [];
			}
		}
		return { categoryList, bundleList };
	}
	getHybridDetailOverlayStyle() {
		return {
			display: this.state.hybridDetailOpen ? "block" : "none",
		};
	}
	toggleText() {
		let textDisplay = document.getElementsByClassName("text")[0].style;
		textDisplay.display = "block";
		if (textDisplay.opacity === "1") {
			document.getElementById("detailsTitle").classList.remove("active");

			textDisplay.opacity = "0";
		} else {
			document.getElementById("detailsTitle").classList.add("active");

			textDisplay.opacity = "1";
		}
		let panel = document.getElementsByClassName("panel")[0];
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + "px";
		}
	}
	clickHandler(e) {
		e.preventDefault();
		const viewMore = e.currentTarget.closest(".view-more");
		const subItems = viewMore.querySelector(".sub-items");
		if (viewMore.classList.contains("active")) {
			viewMore.classList.remove("active");
			subItems.style.display = "none";
		} else {
			viewMore.classList.add("active");
			subItems.style.display = "block";
		}
	}
	rorChargeCall() {
		let landPageData = JSON.parse(sessionStorage.landPageData);
		let url = CustomFunctions.restAPI("/service/getRORCharge");

		const params = {
			t: Math.random(),
			lgId: landPageData.contractInfoCarrier.loggingId,
		};

		fetch(url + "?t=" + params.t + "&lgId=" + params.lgId, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log();
			})
			.catch((error) => {
				console.log("error for rorChargeCall");
			});
	}
	createData2() {
		let UserType = Functions["custom"]["getUserType"]();
		let landPageData = JSON.parse(sessionStorage.landPageData);
		let balanceFormated = sessionStorage.getItem("balanceFormated");
		let output = [];

		if (
			JSON.parse(sessionStorage.getCustomerData).balance >= 0 &&
			this.state.data[0]
		) {
			let creditData = "";
			let contractData = "";
			let contractReloadDateFormated = "";
			let vault = "";
			let businessContractDiv = "";

			let { categoryList, bundleList } = this.getHybridWalletData();

			let lengthOfCategories = categoryList.length;
			let lengthOfBundles = bundleList.length;

			if (lengthOfCategories > 0) {
				for (let k = 0; k < lengthOfCategories; k++) {
					let exp = "";
					if (categoryList[k].name === "PwCVault") {
						for (let n = 0; n < lengthOfBundles; n++) {
							if (bundleList[n].category === "PwCVault") {
								exp = bundleList[n].expiration;
							}
						}
						vault = categoryList[k].monetaryValue + "€";
						output.push(
							<div className="item">
								<div className="col first">
									<img src="/resources/hybrid_wallets/images/icon-hybrid-1.png" />
								</div>
								<div className="col sec">
									<div className="price">
										<span className="vault">{vault} </span>
									</div>
									Το υπόλοιπο σου μέχρι 14/06
								</div>
								<div className="col last">
									Διαθέσιμα έως <br />
									<span className="bundleExpirationVault">{exp}</span>
								</div>
							</div>,
						);
					}
					if (categoryList[k].name === "CoreCredit") {
						for (let n = 0; n < lengthOfBundles; n++) {
							if (bundleList[n].category === "CoreCredit") {
								exp = bundleList[n].expiration;
							}
						}
						creditData = categoryList[k].monetaryValue + "€";
						output.push(
							<div className="item">
								<div className="col first">
									<img src="/resources/hybrid_wallets/images/icon-hybrid-3.png" />
								</div>
								<div className="col sec">
									<div className="price">
										<span className="credit">{creditData}</span>
									</div>
									Υπόλοιπο από ανανεώσεις
								</div>
								<div className="col last">
									Διαθέσιμα έως <br />
									<span className="bundleExpirationCredit">{exp}</span>
								</div>
							</div>,
						);
					}
					if (categoryList[k].name === "PwCContract") {
						let subItems = [];
						if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
							let contractPrice = "";
							for (let n = 0; n < lengthOfBundles; n++) {
								if (bundleList[n].category === "PwCContract") {
									contractPrice = bundleList[n].monetaryValue + "€";
									exp = bundleList[n].expiration;
									subItems.push(
										<div className="sub-item">
											<div className="sub-item-title">
												<strong>
													<span className="contractPrice">{contractPrice}</span>
												</strong>{" "}
												λήγουν στις
											</div>
											<div className="sub-item-date">
												<span className="contractExpirationDate">{exp}</span>
											</div>
										</div>,
									);
								}
							}
						}
						contractData = categoryList[k].monetaryValue + "€";
						contractReloadDateFormated = JSON.parse(
							sessionStorage.getCustomerData,
						).contractReloadDateFormated;

						output.push(
							<div className="item">
								<div className="col first">
									<img src="/resources/hybrid_wallets/images/icon-hybrid-2.png" />
								</div>
								<div className="col sec">
									<div className="price">
										<span className="contract">{contractData}</span>
									</div>
									Υπόλοιπο από το πρόγραμμα σου
								</div>
								<div className="col last">
									<div className="contractMessage">Ανανεώνεται</div>
									<span className="bundleExpirationContract">
										{contractReloadDateFormated}
									</span>
								</div>
								{UserType === "HYBRID_BUSINESS_COST_CONTROL" ? (
									<div className="view-more">
										<a
											style={{ cursor: "pointer" }}
											onClick={this.clickHandler}>
											ΔΕΣ ΑΝΑΛΥΤΙΚΑ
										</a>
										<div className="sub-items">{subItems}</div>
									</div>
								) : null}
							</div>,
						);
					}
				}
				return (
					<div
						className="moreAmount"
						id="moreAmount"
						style={this.getHybridDetailOverlayStyle()}>
						<div className="header">
							<div className="hold">
								<a className="logo"></a>
							</div>
						</div>
						<div className="hybrid-wallet">
							<div className="balance">
								<div className="title">ΣΥΝΟΛΙΚΟ ΥΠΟΛΟΙΠΟ</div>
								<div className="amount">
									<span className="customClassBalanceRemaining">
										{balanceFormated}€
									</span>
									<br />
								</div>
							</div>
							<div className="items">{output}</div>
							<div
								style={{ cursor: "pointer" }}
								onClick={this.closeHybridDetail}
								className="back">
								&lt; ΠΙΣΩ
							</div>
							<div className="notice">
								<div
									onClick={this.toggleText}
									className="title"
									id="detailsTitle">
									<span className="accordion">Το υπόλοπο σου άλλαξε</span>
								</div>
								<div
									className="text panel"
									style={{ transition: "all 0.4s ease 0s" }}>
									Διαχειρίσου το υπόλοιπο σου πιο εύκολα, με τις νέες
									κατηγορίες!
								</div>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<div
						className="moreAmount"
						id="moreAmount"
						style={this.getHybridDetailOverlayStyle()}>
						<div className="header">
							<div className="hold">
								<a className="logo"></a>
							</div>
						</div>
						<div className="hybrid-wallet">
							<div className="balance">
								<div className="title">ΣΥΝΟΛΙΚΟ ΥΠΟΛΟΙΠΟ</div>
								<div className="amount">
									<span className="customClassBalanceRemaining">
										{balanceFormated}€
									</span>
									<br />
								</div>
							</div>
							<div className="items">
								<div
									className="item"
									id="vault"
									style={{ display: "none" }}>
									<div className="col first">
										<img src="/resources/hybrid_wallets/images/icon-hybrid-1.png" />
									</div>
									<div className="col sec">
										<div className="price">
											<span className="vault"> </span>
										</div>
										Το υπόλοιπο σου μέχρι 14/06
									</div>
									<div className="col last">
										Διαθέσιμα έως <br />
										<span className="bundleExpirationVault"></span>
									</div>
								</div>
								<div
									className="item"
									id="contract"
									style={{ display: "none" }}>
									<div className="col first">
										<img src="/resources/hybrid_wallets/images/icon-hybrid-2.png" />
									</div>
									<div className="col sec">
										<div className="price">
											<span className="contract"></span>
										</div>
										Υπόλοιπο από το πρόγραμμα σου
									</div>
									<div className="col last">
										<div className="contractMessage">Ανανεώνεται</div>
										<span className="bundleExpirationContract"></span>
									</div>
								</div>
								<div
									className="item"
									id="credit"
									style={{ display: "none" }}>
									<div className="col first">
										<img src="/resources/hybrid_wallets/images/icon-hybrid-3.png" />
									</div>
									<div className="col sec">
										<div className="price">
											<span className="credit"></span>
										</div>
										Υπόλοιπο από ανανεώσεις
									</div>
									<div className="col last">
										Διαθέσιμα έως <br />
										<span className="bundleExpirationCredit"></span>
									</div>
								</div>
							</div>
							<div
								style={{ cursor: "pointer" }}
								onClick={this.closeHybridDetail}
								className="back">
								&lt; ΠΙΣΩ
							</div>
							<div className="notice">
								<div
									onClick={this.toggleText}
									className="title"
									id="detailsTitle">
									<span className="accordion">Το υπόλοπο σου άλλαξε</span>
								</div>
								<div
									className="text panel"
									style={{ transition: "all 0.4s ease 0s" }}>
									Διαχειρίσου το υπόλοιπο σου πιο εύκολα, με τις νέες
									κατηγορίες!
								</div>
							</div>
						</div>
					</div>
				);
			}
		}
	}
	unlimitedCheckDataForText() {
		let totalDataBalance = this.state.data[0].totalDataBalance.value;
		let allData = this.state.data[0].allData.data.allData;

		if (totalDataBalance == 0) {
			if (
				allData.listOfUnlimitedDataPrepaidNinja.length > 0 &&
				allData.listOfDataBuckets.length > 0
			) {
				let detailsOnly = 1;
				for (let j = 0; j < allData.listOfDataBuckets.length; j++) {
					for (
						let i = 0;
						i < allData.listOfUnlimitedDataPrepaidNinja.length;
						i++
					) {
						if (
							allData.listOfDataBuckets[j].name ==
							allData.listOfUnlimitedDataPrepaidNinja[i].bucket
						) {
							if (!allData.listOfUnlimitedDataPrepaidNinja[i].detailsOnly) {
								detailsOnly = 0;
								break;
							}
						}
					}
				}
				if (detailsOnly == 0) {
					return (
						<>
							<h3
								className="customClassTotalDataBalance"
								style={{ fontSize: "28px" }}>
								<span
									className="customClassTotalDataBalance"
									style={{ fontSize: "28px" }}
									id="availableDataType">
									ΑΠΕΡΙΟΡΙΣΤΑ
								</span>{" "}
								MB
							</h3>
							<h4> ΥΠΟΛΟΙΠΟ </h4>
						</>
					);
				} else {
					return (
						<>
							<h3 className="customClassTotalDataBalance">
								<span
									className="customClassTotalDataBalance"
									id="availableDataType">
									{allData.totalDataBalanceFormated}{" "}
								</span>
								{allData.totalDataBalanceMeasureUnitFormated}
							</h3>

							<h4> ΥΠΟΛΟΙΠΟ </h4>
						</>
					);
				}
			} else {
				return (
					<>
						<h3 className="customClassTotalDataBalance">
							<span
								className="customClassTotalDataBalance"
								id="availableDataType">
								{allData.totalDataBalanceFormated}{" "}
							</span>
							{allData.totalDataBalanceMeasureUnitFormated}
						</h3>

						<h4> ΥΠΟΛΟΙΠΟ </h4>
					</>
				);
			}
		} else {
			if (
				allData.listOfUnlimitedDataPrepaidNinja.length > 0 &&
				allData.listOfDataBuckets.length > 0
			) {
				let detailsOnly = 1;
				for (let j = 0; j < allData.listOfDataBuckets.length; j++) {
					for (
						let i = 0;
						i < allData.listOfUnlimitedDataPrepaidNinja.length;
						i++
					) {
						if (
							allData.listOfDataBuckets[j].name ==
							allData.listOfUnlimitedDataPrepaidNinja[i].bucket
						) {
							if (!allData.listOfUnlimitedDataPrepaidNinja[i].detailsOnly) {
								detailsOnly = 0;
								break;
							}
						}
					}
				}

				if (detailsOnly == 0) {
					return (
						<>
							<h3
								className="customClassTotalDataBalance"
								style={{ fontSize: "28px" }}>
								<span
									className="customClassTotalDataBalance"
									style={{ fontSize: "28px" }}
									id="availableDataType">
									ΑΠΕΡΙΟΡΙΣΤΑ
								</span>{" "}
								MB
							</h3>
							<h4> ΥΠΟΛΟΙΠΟ </h4>
						</>
					);
				} else {
					return (
						<>
							<h3 className="customClassTotalDataBalance">
								<span
									className="customClassTotalDataBalance"
									id="availableDataType">
									{allData.totalDataBalanceFormated}{" "}
								</span>
								{allData.totalDataBalanceMeasureUnitFormated}
							</h3>

							<h4> ΥΠΟΛΟΙΠΟ </h4>
						</>
					);
				}
			} else {
				return (
					<>
						<h3 className="customClassTotalDataBalance">
							<span
								className="customClassTotalDataBalance"
								id="availableDataType">
								{allData.totalDataBalanceFormated}{" "}
							</span>
							{allData.totalDataBalanceMeasureUnitFormated}
						</h3>

						<h4> ΥΠΟΛΟΙΠΟ </h4>
					</>
				);
			}
		}
	}

	createData() {
		let output = [];
		let UserType = Functions["custom"]["getUserType"]();
		let landPageData = JSON.parse(sessionStorage.landPageData);
		this.rorChargeCall();
		let unlimitedDataLand = landPageData.contractInfoCarrier.unlimitedData;
		this.state.data.map((itm, idx) => {
			let availableMBs = "";
			let unlimitedData = "";
			let landPageData = JSON.parse(sessionStorage.landPageData);
			let header;
			if (
				UserType === "POSTB" ||
				UserType === "POSTB_SPLIT" ||
				UserType === "POSTR"
			) {
				availableMBs = itm.items.data.totalRemainingMB;
				unlimitedData = itm.items.data.unlimitedData;
				header = (
					<h5
						id="availableMBHeader"
						className="invislible"
						style={{ lineHeight: "normal", display: "block" }}>
						Τα διαθέσιμα ΜΒ σας για Internet είναι:
					</h5>
				);
			} else {
				let foundedMatch = false;
				if (itm.items.data.allData.listOfDataBuckets.length > 0) {
					for (
						let i = 0;
						i < itm.items.data.allData.listOfDataBuckets.length;
						i++
					) {
						if (
							itm.items.data.allData.listOfUnlimitedDataPrepaidNinja.length > 0
						) {
							for (
								let j = 0;
								j <
								itm.items.data.allData.listOfUnlimitedDataPrepaidNinja.length;
								j++
							) {
								if (
									itm.items.data.allData.listOfUnlimitedDataPrepaidNinja[j]
										.bucket === itm.items.data.allData.listOfDataBuckets[i].name
								) {
									foundedMatch = true;
									unlimitedData = true;
									break;
								}
								if (foundedMatch) break;
							}
						}
					}
				}
				availableMBs = itm.items.data.allData.totalDataBalance;
			}
			if (availableMBs === 0) {
				if (
					landPageData.contractInfoCarrier.hasBuiltInMB &&
					landPageData.contractInfoCarrier.hasInternet
				) {
					header = (
						<h2
							id="allMBsAreConsumedHeader"
							className="invislible"
							style={{ lineHeight: "normal", display: "block" }}>
							Έχετε καταναλώσει
							<br />
							όλα τα MB για Internet
						</h2>
					);
				}
			} else {
				if (unlimitedData) {
					header = (
						<h5
							id="availableMBHeader"
							className="invislible"
							style={{ lineHeight: "normal", display: "block" }}>
							Το διαθέσιμο υπόλοιπο για internet είναι:
						</h5>
					);
				}
			}

			if (
				UserType === "POSTR" &&
				landPageData.contractInfoCarrier.inListOfWhatuspCss
			) {
				if (unlimitedDataLand) {
					header = (
						<h5
							id="availableMBHeader"
							className="invislible"
							style={{ lineHeight: "normal", display: "block" }}>
							Το διαθέσιμο υπόλοιπο για internet είναι:
						</h5>
					);
				} else {
					header = (
						<h5
							id="availableMBHeader"
							className="invislible"
							style={{ lineHeight: "normal", display: "block" }}>
							Τα διαθέσιμα ΜΒ σας για Internet είναι:
						</h5>
					);
				}
			}

			let mBsTitle = "";

			if (unlimitedData) {
				mBsTitle = (
					<h3 style={{ fontSize: "80px", lineHeight: "90px" }}>
						&infin; <span id="availableDataType"></span>
					</h3>
				);
			} else {
				mBsTitle = (
					<h3>
						<span id="availableDataAmount">
							{itm.totalRemainingDataDisplay.component}
						</span>{" "}
						{itm.totalRemainingDataMeasUnitDisplay.component}
					</h3>
				);
			}
			output.push(
				<div key={idx}>
					<div
						className="home-remain"
						id="home-remain">
						{UserType === "POSTR" ||
						UserType === "POSTB_SPLIT" ||
						UserType === "POSTB" ? (
							<div className="hold">
								{header}
								<div className="mb-remain">
									{mBsTitle}
									{unlimitedData ? (
										<h4 className="nolimit"> Απεριόριστα GB </h4>
									) : (
										<h4 className="remain-mb"> ΥΠΟΛΟΙΠΟ </h4>
									)}
									{itm.showInfo.component}
									<div className="last-update">
										Τελευταία ενημέρωση:
										<span id="infoUpdateDate">
											{" "}
											{itm.lastUpdateDate.component}
										</span>
									</div>
								</div>
							</div>
						) : (
							<div className="hold">
								{itm.totalDataBalance.value === 0 &&
								itm.items.data.allData.listOfDataBuckets.length === 0 ? (
									<div>
										{UserType === "PREPAID_COSMOKARTA" ||
										UserType === "PREPAID_FROG" ||
										UserType === "PREPAID_WHATSUP" ||
										UserType === "NEO" ? (
											<h2
												className="customDisplayNone customRemainingDataMessageConsumed"
												style={{ lineHeight: "normal", display: "block" }}>
												Δεν έχεις ΜΒ για σερφάρισμα
											</h2>
										) : UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ? (
											landPageData.contractInfoCarrier.inListOfWhatuspCss &&
											unlimitedData ? (
												<h2
													className="customDisplayNone customRemainingDataMessageConsumed"
													style={{ lineHeight: "normal", display: "block" }}>
													Τα διαθέσιμα ΜΒ σου
													<br /> για Internet είναι:
												</h2>
											) : (
												<h2
													className="customDisplayNone customRemainingDataMessageConsumed"
													style={{ lineHeight: "normal", display: "block" }}>
													Έχεις καταναλώσει
													<br />
													όλα τα MB για Internet
												</h2>
											)
										) : (
											<h2
												className="customDisplayNone customRemainingDataMessageConsumed"
												style={{ lineHeight: "normal", display: "block" }}>
												Έχετε καταναλώσει
												<br />
												όλα τα MB για Internet
											</h2>
										)}
									</div>
								) : (
									<>
										{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
										UserType === "HYBRID_BUSINESS_COST_CONTROL" ? (
											<h6
												className="customRemainingDataNotConsumed"
												style={{ lineHeight: "normal", display: "block" }}>
												{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
													? "Τα διαθέσιμα MB σου για Internet είναι"
													: "Τα διαθέσιμα MB σας για Internet είναι"}
											</h6>
										) : (
											<h6
												className="customRemainingDataNotConsumed"
												style={{ lineHeight: "normal", display: "block" }}>
												Για σερφάρισμα έχεις:
											</h6>
										)}
									</>
								)}
								<div className="mb-remain">
									{this.unlimitedCheckDataForText()}
									{itm.showInfo.component}
									<div className="last-update">
										Τελευταία ενημέρωση:
										<span id="infoUpdateDate">
											{" "}
											{itm.availableMBsLastUpdateDateFormated.component}
										</span>
									</div>
								</div>
							</div>
						)}
						{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
						UserType === "HYBRID_BUSINESS_COST_CONTROL" ? (
							<div className="new-ammount-remain">
								<div className="line"></div>
								<div className="row">
									<div className="col first">
										ΧΡΗΜΑΤΙΚΟ ΥΠΟΛΟΙΠΟ{" "}
										<span className="price customClassBalanceRemaining">
											{itm.balanceFormated.value}€
										</span>
										<br />
									</div>
									<div className="col last">
										<a
											style={{ cursor: "pointer" }}
											onClick={this.openHybridDetail}>
											Αναλυτικά
										</a>
									</div>
								</div>
								<div className="line"></div>
							</div>
						) : null}
					</div>
					{(itm.totalOffPeakMB.data.totalOffPeakMB >= 0 ||
						itm.totalDataBalance !== 0) &&
					!(
						UserType === "POSTB" ||
						UserType === "POSTB_SPLIT" ||
						UserType === "POSTR" ||
						UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
						UserType === "HYBRID_BUSINESS_COST_CONTROL"
					) ? (
						<div
							className={
								itm.unlimitedData.data.unlimitedData === true ||
								itm.balance === 0
									? "ammount-remain hidden"
									: "ammount-remain"
							}>
							<div className="line"></div>
							<div className="hold">
								<h4>
									ΧΡΗΜΑΤΙΚΟ ΥΠΟΛΟΙΠΟ{" "}
									<span className="customClassBalanceRemaining">
										{/*this.amountFormat(itm.balanceFormated.component,landPageData.contractInfoCarrier.inListOfWhatuspCss)*/}
										{UserType === "PREPAID_WHATSUP"
											? itm.balanceFormated.value + " "
											: itm.balanceFormated.value}
										€
									</span>
								</h4>
								{itm.allData.data.allData.balance !== 0 ? (
									<h5 className="customClassBalanceRemainingExpirationDate">
										Διαθέσιμο έως, {itm.balanceExpirationFormated.component}
									</h5>
								) : (
									""
								)}
							</div>
							<div className="line"></div>
						</div>
					) : null}
					{(UserType === "POSTB" ||
						UserType === "POSTR" ||
						UserType === "POSTB_SPLIT") &&
					itm.totalOffPeakMB.data.totalOffPeakMB >= 0 ? (
						<div className="ammount-remain">
							<div className="line"></div>
							<div className="hold">
								<h4 className="remainmb">
									+
									<span className="customClassBalanceRemaining">
										{itm.totalOffPeakMB.data.totalOffPeakMB}{" "}
										{itm.totalOffPeakMB.data.totalOffPeakMeasUnitDisplay}
									</span>
								</h4>
								<div className="remainmbduration">από 00:00 - 08:00</div>
							</div>
							<div className="line"></div>
						</div>
					) : null}
				</div>,
			);
		});

		if (
			UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
			UserType === "HYBRID_BUSINESS_COST_CONTROL"
		) {
			output.push(this.createData2());
		}
		return <div>{output}</div>;
	}

	clickMe() {
		let manager = this.props.manager;
		window["modal"].setState({
			// title: <h4>Confirm deletion</h4>,
			targetComponent: this,
			show: true,
			callback: function (args) {
				window["modal"].setState({ show: false });
				setTimeout(manager.refresh, 2000);
			},
			// footer: [],
			body: (
				<Manager
					module="infoPopUp"
					inputData={[this.props.data]}
					view="list"
					ref={(refComponent) => {
						window["modalbody"] = refComponent;
					}}></Manager>
			),
		});
	}
	customersWithNoData() {
		let UserType = Functions["custom"]["getUserType"]();
		return (
			<>
				<div className="home-remain">
					<div className="hold">
						{["POSTR", "POSTB", "POSTB_SPLIT"].includes(UserType) ? (
							<h2 className="customDisplayNone customRemainingDataMessageConsumed">
								Δεν έχεις ΜΒ για σερφάρισμα
							</h2>
						) : (
							<h6 className="customRemainingDataNotConsumed">
								Για σερφάρισμα έχεις:
							</h6>
						)}
						<div className="mb-remain">
							<h3 className="customClassTotalDataBalance">
								<span className="customClassTotalDataBalance"></span>
							</h3>
							<h4>ΥΠΟΛΟΙΠΟ</h4>
							<a
								className="view-statistics open-lightbox"
								id="statisticsLink"
								style={{ cursor: "pointer" }}
								onClick={(e) => this.clickMe(this)}>
								<span>Αναλυτικά</span>
							</a>
							<div className="last-update">
								Τελευταία ενημέρωση:{" "}
								<span className="customClassAvailableMBsLastUpdateDate"></span>
							</div>
						</div>
					</div>
				</div>

				{["POSTR", "POSTB", "POSTB_SPLIT"].includes(UserType) ? null : (
					<div className="ammount-remain">
						<div className="line"></div>
						<div className="hold">
							<h4>
								ΧΡΗΜΑΤΙΚΟ ΥΠΟΛΟΙΠΟ{" "}
								<span className="customClassBalanceRemaining"></span>
							</h4>
							<h5 className="customClassBalanceRemainingExpirationDate">
								Διαθέσιμο έως,{" "}
							</h5>
						</div>
						<div className="line"></div>
					</div>
				)}
			</>
		);
	}

	render() {
		if (this.state.loaded) {
			if (this.state.data.length === 0) {
				return this.customersWithNoData();
			}
			return this.createData();
		} else {
			return "";
		}
	}
}

export default InfoDataPanel;
